exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  overflow: overlay;\n  width: 18px; }\n\n/* Scrollbar */\n/* width */\n.container::-webkit-scrollbar {\n  width: 16px; }\n\n/* Track */\n.container::-webkit-scrollbar-track {\n  background: transparent;\n  box-shadow: inset 0 0 50px #e4eaea;\n  border-radius: 10px;\n  border: 5px solid transparent; }\n\n/* Handle */\n.container::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 40px;\n  border: 5px solid transparent;\n  box-shadow: 0 0 0 18px #707070 inset; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/side-menu-scroller/side-menu-scroller.component.scss
// module id = ../../../../../src/app/components/common/side-menu-scroller/side-menu-scroller.component.scss
// module chunks = 0